import { toast } from 'react-hot-toast'
import { ERROR_MESSAGES } from '@/data/constants'
import type { ApiError } from '@/types'

export const handleValidationError = (data?: ApiError) => {
  if (data?.details) {
    Object.values(data.details).forEach((message: unknown) => {
      toast.error(message as string)
    })
  } else {
    toast.error(data?.message || ERROR_MESSAGES.BAD_REQUEST)
  }
}